/* eslint-disable @typescript-eslint/no-explicit-any */
import { TransactionType } from '@/defines/EnumDefine'
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { MsgIDs } from '@/defines/MsgIDs'
import { serverErrorMsg } from '@/defines/ServerError'
import { base } from '@/base/base'
import * as proto from '@/proto/proto.js'

export class TransactionModule extends ModuleBase {
  // withDrawRecordList: any[] = [];
  // payRecordList: any[] = [];

  PAGE_SIZE: number = 20

  startTime: number = 0
  endTime: number = 0
  pageIndex: number = 0

  balanceRecords: Record<number, any[]> = {}
  getedAllRecords: boolean = false

  init(): void {
    this.resetReqData()
  }

  onClear(): void {
    // this.withDrawRecordList = [];
    // this.payRecordList = [];

    this.pageIndex = 0
    this.balanceRecords = {}
    this.getedAllRecords = false
  }
  onLoad(): void {}
  onDestroy(): void {}
  onPreloadData(): void {}

  // 已废弃
  // sendReqWithDrawRecord() {
  //     let message = {
  //         UserID: hall.userModule.userId
  //     }
  //     hall.network.send(MsgIDs.Client2ProxyReqWithDrawRecord, message)
  // }

  // 已废弃
  // sendReqGetPayRecord() {
  //     let message = {
  //         UserID: hall.userModule.userId
  //     }
  //     hall.network.send(MsgIDs.Client2ProxyReqGetPayRecord, message)
  // }

  resetReqData() {
    this.pageIndex = 0

    const date = new Date()
    date.setHours(24, 0, 0, 0)
    this.endTime = Math.floor(date.getTime() / 1000)
    this.startTime = this.endTime - 2 * 24 * 60 * 60

    this.balanceRecords = {}
    for (const key in TransactionType) {
      // 过滤掉反向映射的数字键
      if (isNaN(Number(key))) {
        this.balanceRecords[(TransactionType as any)[key]] = []
      }
    }
  }

  sendReqAllBalanceDetail() {
    this.resetReqData()

    this._sendReqBalanceDetail(TransactionType.All, this.pageIndex)
  }

  // 获取2天内的记录
  // pageIndex 从0开始
  _sendReqBalanceDetail(transType: TransactionType, pageIndex: number) {
    const message = {
      UserID: hall.userModule.userId,
      QueryType: transType,
      StartTimestamp: this.startTime,
      EndTimestamp: this.endTime,
      PageInfo: {
        Page: pageIndex,
        PageSize: this.PAGE_SIZE,
      },
    }

    hall.network.send(MsgIDs.Client2ProxyReqBalanceDetail, message)
  }

  _disposeRecords(records: any[]) {
    for (let i = 0; i < records.length; i++) {
      // 赢：1
      // 输：2
      // 充值：3
      // 提现：4
      // 活动所有：5
      const record = records[i]
      record._transType_ = Number(record.BalanceType)
      
      if (!this.balanceRecords[TransactionType.All]) {
        this.balanceRecords[TransactionType.All] = []
      }
      this.balanceRecords[TransactionType.All]!.push(record)
      
      if (!this.balanceRecords[record._transType_]) {
        this.balanceRecords[record._transType_] = []
      }
      this.balanceRecords[record._transType_]!.push(record)

      // let record = records[i];
      // // BalanceType 明细类型(1:充值;2:提现;3:对局;4:赠金)
      // let transType = TransactionType.None;
      // switch (record.BalanceType) {
      //     case "1":
      //         transType = TransactionType.MoneyAdded;
      //         break;
      //     case "2":
      //         transType = TransactionType.Withdraw;
      //         break;
      //     case "3":
      //         let amount = parseFloat(record.Amount)
      //         if (!isNaN(amount)) {
      //             if (amount > 0) {
      //                 transType = TransactionType.Won;
      //             } else {
      //                 transType = TransactionType.Lose;
      //             }
      //         }
      //         break;
      //     case "4":
      //         transType = TransactionType.Bonus;
      //         break;
      // }

      // // 类型，客户端使用
      // record._transType_ = transType

      // if (transType != TransactionType.None) {
      //     this.balanceRecords[TransactionType.All].push(record);
      //     this.balanceRecords[transType].push(record);
      // }
    }
  }

  getRecords(transType: TransactionType) {
    return this.balanceRecords[transType]
  }

  inits2c(): void {
    // 弃用
    // hall.s2c.onClient2ProxyAckWithDrawRecord = (msg: proto.Client2ProxyAckWithDrawRecord) => {
    //     if (msg.Res == 0) {
    //         this.withDrawRecordList = msg.RecordList
    //         hall.eventDispatcher.emit(hall.EventDefine.TransactionDataChange, TransactionType.Withdraw)
    //     } else {
    //         base.toast(serverErrorMsg(msg.Res));
    //     }
    // };

    // hall.s2c.onClient2ProxyAckGetPayRecord = (msg: proto.Client2ProxyAckGetPayRecord) => {
    //     this.payRecordList = msg.PayRecordList
    //     hall.eventDispatcher.emit(hall.EventDefine.TransactionDataChange, TransactionType.MoneyAdded)

    // };

    ;(hall.s2c as any)['onClient2ProxyAckBalanceDetail'] = (msg: proto.Client2ProxyAckBalanceDetail) => {
      if (msg.Ret == 0) {
        this._disposeRecords(msg.BalanceDetail)

        this.pageIndex = msg.PageInfo.PageSize
        if (msg.BalanceDetail.length < this.PAGE_SIZE) {
          this.getedAllRecords = true
        } else {
          this._sendReqBalanceDetail(TransactionType.All, this.pageIndex++)
        }

        hall.eventDispatcher.emit(hall.EventDefine.TransactionDataChange)
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
    }
  }
}
